.card {
  border-radius: 1.75rem;
  box-shadow:
    0 1.25rem 3rem rgba(15, 23, 42, 0.14),
    0 0.35rem 1rem rgba(15, 23, 42, 0.08);
  overflow: hidden;
}

